import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import RootLayout from '@/layouts/RootLayout.vue';

/**
 * 个人中心-模块
 */
var account = {
  path: '/account',
  redirect: '/account/index',
  component: RootLayout,
  children: [{
    path: 'cashToUp',
    name: 'cashToUp',
    component: function component() {
      return import('views/account/cashToUp/CashToUp');
    },
    meta: {
      title: '充值'
    }
  }, {
    path: 'cashOrder',
    name: 'CashOrder',
    component: function component() {
      return import('views/account/cashToUp/CashOrder');
    },
    meta: {
      title: '充值订单'
    }
  }, {
    path: 'cashDetail',
    name: 'CashDetail',
    component: function component() {
      return import('views/account/cashToUp/CashDetail');
    },
    meta: {
      title: '账单',
      keepAlive: true
    }
  }, {
    path: 'billDetail',
    name: 'BillDetail',
    component: function component() {
      return import('views/account/cashToUp/BillDetail');
    },
    meta: {
      title: '账单详情'
    }
  }, {
    path: 'withdraw',
    name: 'Withdraw',
    component: function component() {
      return import('views/account/cashToUp/withdraw/Withdraw');
    },
    meta: {
      title: '提现'
    }
  }, {
    path: 'withdrawRecord',
    name: 'WithdrawRecord',
    component: function component() {
      return import('views/account/cashToUp/withdraw/WithdrawRecord');
    },
    meta: {
      title: '提现记录'
    }
  }, {
    path: 'WithdrawalDetail',
    name: 'WithdrawalDetail',
    component: function component() {
      return import('views/account/cashToUp/withdraw/WithdrawalDetail');
    },
    meta: {
      title: '提现详情'
    }
  }, {
    path: 'cashWallet',
    name: 'cashWallet',
    component: function component() {
      return import('views/account/cashToUp/CashWallet');
    },
    meta: {
      title: '钱包详情'
    }
  }, {
    path: 'bankCard',
    name: 'BankCard',
    component: function component() {
      return import('views/account/cashToUp/bankCard/BankCard');
    },
    meta: {
      title: '银行卡'
    }
  }, {
    path: 'index',
    name: 'AccountIndex',
    component: function component() {
      return import('views/account/Index');
    },
    meta: {
      title: '我的',
      keepAlive: true,
      auth: true
    }
  }, {
    path: 'accountMeans',
    name: 'AccountMeans',
    component: function component() {
      return import('views/account/userInfo/AccountMeans');
    },
    meta: {
      title: '账号信息'
    }
  }, {
    path: 'project',
    name: 'AccountProject',
    component: function component() {
      return import('@/views/account/project/index.vue');
    },
    meta: {
      title: '项目详情',
      auth: true
    }
  },
  // {
  //   path: 'setDisplayName',
  //   name: 'SetDisplayName',
  //   component: () => import('views/account/userInfo/SetDisplayName'),
  //   meta: {
  //     title: '修改昵称'
  //   }
  // },
  {
    path: 'realTypeSelect',
    name: 'RealTypeSelect',
    component: function component() {
      return import('views/account/realNameAuth/RealTypeSelect');
    },
    meta: {
      title: '实名认证'
    }
  }, {
    path: 'realNameInfo',
    name: 'RealNameInfo',
    component: function component() {
      return import('views/account/userInfo/RealNameInfo');
    },
    meta: {
      title: '账号信息'
    }
  }, {
    path: 'company',
    name: 'CompanyAuth',
    component: function component() {
      return import('views/account/realNameAuth/Company');
    },
    meta: {
      title: '企业实名认证'
    }
  }, {
    path: 'HelpCenter',
    name: 'HelpCenter',
    component: function component() {
      return import('views/account/HelpCenter');
    },
    meta: {
      title: '帮助中心'
    }
  }, {
    path: '/account/MyMedal',
    name: 'MyMedal',
    component: function component() {
      return import('views/account/other/MyMedal');
    },
    meta: {
      title: '我的勋章'
    }
  }, {
    path: '/account/MyConcern',
    name: 'MyConcern',
    component: function component() {
      return import('views/account/other/MyConcern');
    },
    meta: {
      title: '我的关注'
    }
  }, {
    path: '/account/userHome',
    name: 'UserHome',
    component: function component() {
      return import('views/account/UserHome');
    },
    meta: {
      title: '主页'
    }
  }, {
    path: 'makeDraw',
    name: 'MakeDraw2',
    component: function component() {
      return import('views/account/draw/MakeDraw');
    },
    meta: {
      title: '预约抽签'
    }
  }, {
    path: 'myMake',
    name: 'MyMake',
    component: function component() {
      return import('views/account/draw/MyMake');
    },
    meta: {
      title: '我的预约'
    }
  }, {
    path: 'makeDetails',
    name: 'MakeDetails',
    component: function component() {
      return import('views/account/draw/MakeDetails');
    },
    meta: {
      title: '预约详情'
    }
  }, {
    path: 'drawDetails',
    name: 'DrawDetails',
    component: function component() {
      return import('views/account/draw/DrawDetails');
    },
    meta: {
      title: '中签详情'
    }
  }, {
    path: 'confirmation',
    name: 'Confirmation',
    component: function component() {
      return import('@/views/account/registerCompany/Confirmation');
    },
    meta: {
      title: '办理确认书'
    }
  }, {
    path: 'result',
    name: 'Result',
    component: function component() {
      return import('@/views/account/registerCompany/Result');
    },
    meta: {
      title: '办理结果'
    }
  }, {
    path: 'fyPersonAuth',
    name: 'FYPersonalAuth',
    component: function component() {
      return import('@/views/account/fyWallet/PersonalAuth');
    },
    meta: {
      title: '个人实名-基础认证'
    }
  }, {
    path: 'fyAuthResult',
    name: 'FYAuthResult',
    component: function component() {
      return import('@/views/account/fyWallet/AuthResult');
    },
    meta: {
      title: '个人实名-基础认证'
    }
  }, {
    path: 'fyIdAuthService',
    name: 'FYService',
    component: function component() {
      return import('@/views/account/fyWallet/Service');
    },
    meta: {
      title: '钱包开通须知'
    }
  }, {
    path: 'fyIdAuth',
    name: 'FYIdentityAuth',
    component: function component() {
      return import('@/views/account/fyWallet/IdentityAuth');
    },
    meta: {
      title: '身份验证',
      keepAlive: true
    }
  }, {
    path: 'fyIdResult',
    name: 'FYIdentityResult',
    component: function component() {
      return import('@/views/account/fyWallet/IdentityResult');
    },
    meta: {
      title: '身份验证'
    }
  }, {
    path: 'selectBank',
    name: 'SelectBank',
    component: function component() {
      return import('@/views/account/fyWallet/SelectBank');
    },
    meta: {
      title: '选择银行'
    }
  }, {
    path: 'companyBankList',
    name: 'CompanyBankList',
    component: function component() {
      return import('@/views/account/fyWallet/CompanyBankList');
    },
    meta: {
      title: '选择银行'
    }
  }, {
    path: '/account/ForRecord',
    name: 'ForRecord',
    component: function component() {
      return import('views/account/ExchangeRecord/Index');
    },
    meta: {
      title: '兑换记录'
    }
  }, {
    path: '/account/entity',
    // 实物权益兑换详情
    name: 'ExchangeRecordEntity',
    component: function component() {
      return import('views/account/ExchangeRecord/Entity');
    },
    meta: {
      title: '兑换详情'
    }
  }, {
    path: '/account/virtual',
    // 虚拟权益兑换详情
    name: 'ExchangeRecordVirtual',
    component: function component() {
      return import('views/account/ExchangeRecord/Virtual');
    },
    meta: {
      title: '兑换详情'
    }
  }, {
    path: '/account/priority',
    // 优先购权益兑换详情
    name: 'ExchangeRecordPriority',
    component: function component() {
      return import('views/account/ExchangeRecord/Priority');
    },
    meta: {
      title: '兑换详情'
    }
  },
  // 单次优惠券类兑换详情
  {
    path: '/account/coupon',
    name: 'ExchangeRecordCoupon',
    component: function component() {
      return import('@/views/account/ExchangeRecord/Coupon.vue');
    },
    meta: {
      title: '兑换详情'
    }
  }, {
    path: '/account/transferRecord',
    name: 'TransferRecord',
    component: function component() {
      return import('views/account/transfer/TransferRecord');
    },
    meta: {
      title: '转移记录'
    }
  }, {
    path: '/account/transferRecord/:id',
    name: 'TransferRecordDetail',
    component: function component() {
      return import('views/account/transfer/RecordDetail');
    },
    meta: {
      title: '记录详情'
    }
  }, {
    path: '/account/reGiftRecord',
    name: 'ReGiftRecord',
    component: function component() {
      return import('@/views/account/other/ReGiftRecord');
    },
    meta: {
      title: '转赠记录',
      keepAlive: true
    }
  }, {
    path: '/manageDN',
    name: 'DomainNameManage',
    component: function component() {
      return import('@/views/account/DomainName/ManageDN');
    },
    meta: {
      title: '数字身份管理',
      auth: true
    }
  }, {
    path: '/digitalIdentityIntroduce',
    name: 'DigitalIdentityIntroduce',
    component: function component() {
      return import('@/views/account/DomainName/components/DigitalIdentityIntroduce');
    },
    meta: {
      title: '数字身份介绍'
    }
  }, {
    path: '/myDN',
    name: 'MyDomainName',
    component: function component() {
      return import('@/views/account/DomainName/MyDN');
    },
    meta: {
      title: '我的数字身份'
    }
  }, {
    path: '/searchDN',
    name: 'DomainNameSearchList',
    component: function component() {
      return import('@/views/account/DomainName/SearchListDN');
    },
    meta: {
      title: '数字身份查询'
    }
  },
  // 注册数字身份（权益）
  {
    path: '/exchangeDN',
    name: 'ExchangeDN',
    component: function component() {
      return import('@/views/account/DomainName/ExchangeDN');
    },
    meta: {
      title: '兑换详情'
    }
  },
  // 数字身份解析（权益）
  {
    path: '/resoluteDN',
    name: 'ResoluteDN',
    component: function component() {
      return import('@/views/account/DomainName/ResoluteDN');
    },
    meta: {
      title: '兑换详情'
    }
  },
  // 注册数字身份（我的）
  {
    path: '/registerDN',
    name: 'DomainNameRegister',
    component: function component() {
      return import('@/views/account/DomainName/RegisterDN');
    },
    meta: {
      title: '注册数字身份'
    }
  },
  // 数字身份解析（我的）
  {
    path: '/resoluteMyDN',
    name: 'ResoluteMyDN',
    component: function component() {
      return import('@/views/account/DomainName/ResoluteMyDN');
    },
    meta: {
      title: '数字身份解析'
    }
  },
  // 超链设置
  {
    path: '/setSupLink',
    name: 'SetSupLink',
    component: function component() {
      return import('@/views/account/DomainName/SetSupLink');
    },
    meta: {
      title: '超链设置'
    }
  },
  // 绑定web2.0
  {
    path: '/bindWebV2',
    name: 'BindWebV2',
    component: function component() {
      return import('@/views/account/DomainName/BindWebV2');
    },
    meta: {
      title: '绑定web2.0'
    }
  },
  // 绑定社交媒体
  {
    path: '/bindTikTok',
    name: 'BindTikTok',
    component: function component() {
      return import('@/views/account/DomainName/BindTikTok');
    },
    meta: {
      title: '绑定社交媒体'
    }
  },
  // 绑定藏品
  {
    path: '/bindNFR',
    name: 'BindNFR',
    component: function component() {
      return import('@/views/account/DomainName/BindNFR');
    },
    meta: {
      title: '绑定藏品'
    }
  },
  // {
  //   path: '/walletList',
  //   name: 'WalletList',
  //   component: () => import('views/account/WalletList'),
  //   meta: {
  //     title: '钱包列表'
  //   }
  // },
  // 线下核销兑换详情
  {
    path: '/account/chargeOff',
    name: 'ExchangeOfflineChargeOff',
    component: function component() {
      return import('views/account/ExchangeRecord/OfflineChargeOff');
    },
    meta: {
      title: '兑换详情'
    }
  }, {
    path: '/account/userLevel',
    name: 'UserLevel',
    component: function component() {
      return import('views/account/userInfo/userLevel.vue');
    },
    meta: {
      title: '用户等级'
    }
  }]
};
export default account;